module.exports = __webpack_public_path__ + "static/media/OfficeEnviro.3870c1a1.jpg";